import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
const eTicketEndpoints = {
    get: 'api/eticket/get',
    feedback: 'api/eticket/feedback',
    voting: 'api/eticket/voting',
};
class EticketAPI {
    constructor() {
        this.getTicketInformation = (defaultRequestParams, servicesApi, customerUUID, saleId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}${eTicketEndpoints.get}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId }),
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.voting = (defaultRequestParams, servicesApi, customerUUID, saleId, ratingType, rating, departmentId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${eTicketEndpoints.voting}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId,
                    rating,
                    ratingType,
                    departmentId }),
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.sendFeedback = (defaultRequestParams, servicesApi, customerUUID, saleId, feedback) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${eTicketEndpoints.feedback}`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID,
                    saleId }),
                data: feedback,
                headers: {
                    'Content-Type': 'text/plain',
                },
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new EticketAPI();
